export class Vehicle {
    public id: number;
    public model: string;
    public vin: string;
    public capacity: number;
    public created: string;
    constructor(id: number, model: string, vin: string, capacity: number, created: string) {
        this.id = id;
        this.model = model;
        this.vin = vin;
        this.capacity = capacity;
        this.created = created;
    }
}

export class VehicleCreate {
    public id: number;
    public model: string;
    public vin: string;
    public capacity: number;
    public created: string;
    constructor(model: string, vin: string, capacity: number) {
        this.model = model;
        this.vin = vin;
        this.capacity = capacity;
    }
}

export class VehicleUpdate {
    public id: number;
    public model: string;
    public vin: string;
    public capacity: number;
    constructor(id: number, model: string, vin: string, capacity: number) {
        this.id = id;
        this.model = model;
        this.vin = vin;
        this.capacity = capacity;
    }
}
